.container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  @media screen and (min-width: $bp-medium) {
    gap: 1.2rem;
  }
}

.teams-container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media screen and (min-width: $bp-medium) {
    gap: 2.4rem;
  }
}
